// Currency support for calculators

export const CURRENCIES = [
  { code: "USD", symbol: "$",  name: "US Dollar",          locale: "en-US" },
  { code: "EUR", symbol: "€",  name: "Euro",               locale: "de-DE" },
  { code: "GBP", symbol: "£",  name: "British Pound",      locale: "en-GB" },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar",    locale: "en-CA" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar",  locale: "en-AU" },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar", locale: "en-NZ" },
  { code: "INR", symbol: "₹",  name: "Indian Rupee",       locale: "en-IN" },
  { code: "JPY", symbol: "¥",  name: "Japanese Yen",       locale: "ja-JP" },
  { code: "MXN", symbol: "$",  name: "Mexican Peso",       locale: "es-MX" },
  { code: "BRL", symbol: "R$", name: "Brazilian Real",     locale: "pt-BR" },
  { code: "ZAR", symbol: "R",  name: "South African Rand", locale: "en-ZA" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar",   locale: "en-SG" },
  { code: "PHP", symbol: "₱",  name: "Philippine Peso",    locale: "en-PH" },
  { code: "KRW", symbol: "₩",  name: "Korean Won",         locale: "ko-KR" },
  { code: "CHF", symbol: "CHF", name: "Swiss Franc",       locale: "de-CH" },
];

export const CURRENCY_MAP = Object.fromEntries(CURRENCIES.map((c) => [c.code, c]));

export function currencyInfo(code) {
  return CURRENCY_MAP[code] || CURRENCIES[0];
}

export function fmtMoney(amount, code = "USD") {
  const c = currencyInfo(code);
  if (!isFinite(amount)) return "—";
  const noDecimals = code === "JPY" || code === "KRW";
  const decimals = noDecimals ? 0 : 2;
  return `${c.symbol}${amount.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
}
